import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const plans = [
  {
    name: 'Starter',
    subtitle: 'Ideal for early-stage startups',
    features: ['Monthly MIS report', 'GST filing support', '2 strategy calls/month', 'Basic compliance calendar'],
    cta: 'Get Started',
    highlight: false,
  },
  {
    name: 'Growth',
    subtitle: 'Ideal for scaling SMEs',
    features: ['Full Virtual CFO function', 'Budgeting & forecasting', 'Investor & board reporting', 'Cash flow management', '4 strategy calls/month'],
    cta: 'Book a Call',
    highlight: true,
  },
  {
    name: 'Enterprise',
    subtitle: 'For larger businesses & special projects',
    features: ['Custom scope of work', 'Fundraising & IPO support', 'M&A and transaction advisory', 'International tax structuring', 'Dedicated CA partner access'],
    cta: "Let's Talk",
    highlight: false,
  },
];

export const EngagementSection = ({ onBookAppointment }) => (
  <section id="pricing" className="py-16 sm:py-20 px-4 sm:px-6 bg-white">
    <div className="max-w-7xl mx-auto">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-3">Flexible Engagement Models</h2>
      <p className="text-gray-600 text-center mb-10 sm:mb-12 max-w-2xl mx-auto">Choose a model that fits your business stage. No rigid contracts — just results.</p>
      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        {plans.map((p, i) => (
          <div key={p.name || `plan-${i}`} className={`rounded-2xl p-6 sm:p-8 border-2 ${p.highlight ? 'border-emerald-500 bg-emerald-50/30 shadow-xl relative' : 'border-gray-200 bg-white'}`}>
            {p.highlight && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-emerald-600 text-white text-xs font-bold px-4 py-1 rounded-full">MOST POPULAR</span>
            )}
            <h3 className="text-xl font-bold text-gray-900 mb-1">{p.name}</h3>
            <p className="text-sm text-gray-600 mb-6">{p.subtitle}</p>
            <ul className="space-y-3 mb-6">
              {p.features.map((f, j) => (
                <li key={j} className="flex items-start gap-2 text-sm text-gray-700">
                  <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <Button
              onClick={onBookAppointment}
              className={`w-full rounded-full py-5 text-sm font-semibold ${p.highlight ? 'bg-emerald-600 hover:bg-emerald-700 text-white' : 'bg-gray-900 hover:bg-gray-800 text-white'}`}
            >
              {p.cta} <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <p className="text-xs text-gray-500 text-center mt-3">Custom pricing — book a call to discuss your requirements.</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
